<nb-card>
    <nb-card-header class="d-flex pb-0 pe-3">
        <morva-icons icon="error"></morva-icons>
        <span data-testid="datasource-name" class="text me-1">{{title}}</span></nb-card-header>
    <nb-card-body>
        <p class="text">{{message}}</p>
        <div class="d-flex align-items-center justify-content-center">
            <button class="force-update" (click)="showWarnings()">به‌روزرسانی
                اجباری
            </button>
            <button class="confirm" (click)="close()">تایید</button>
        </div>
    </nb-card-body>
</nb-card>

